import { useState, useEffect } from "react";
import { useLenis } from "@/hooks/useLenis";
import { AnnouncementBar } from "@/components/store/AnnouncementBar";
import { Navbar } from "@/components/store/Navbar";
import { Hero } from "@/components/store/Hero";
import { Marquee } from "@/components/store/Marquee";
import { InsideGuide } from "@/components/store/InsideGuide";
import { HowItWorks } from "@/components/store/HowItWorks";
import { Comparison } from "@/components/store/Comparison";
import { Reviews } from "@/components/store/Reviews";
import { ObjectionCrusher } from "@/components/store/ObjectionCrusher";
import { Faq } from "@/components/store/Faq";
import { StickyBuyBar } from "@/components/store/StickyBuyBar";
import { CheckoutModal } from "@/components/store/CheckoutModal";
import { Concierge } from "@/components/store/Concierge";
import { SocialProofToast } from "@/components/store/SocialProofToast";
import { ExitIntent } from "@/components/store/ExitIntent";
import { Footer } from "@/components/store/Footer";

export default function Storefront() {
  useLenis();
  const [checkoutOpen, setCheckoutOpen] = useState(false);

  useEffect(() => {
    const promo = new URLSearchParams(window.location.search).get("promo");
    if (promo === "COMEBACK10") {
      localStorage.setItem("astra_promo", promo);
    }
  }, []);

  const openCheckout = () => setCheckoutOpen(true);

  return (
    <div id="top" data-testid="storefront-page" className="min-h-screen overflow-x-hidden bg-[#07090e]">
      <AnnouncementBar />
      <Navbar onBuy={openCheckout} />
      <Hero onBuy={openCheckout} />
      <Marquee />
      <InsideGuide />
      <HowItWorks />
      <Comparison />
      <Reviews />
      <ObjectionCrusher onBuy={openCheckout} />
      <Faq />
      <Footer />
      <StickyBuyBar onBuy={openCheckout} />
      <CheckoutModal open={checkoutOpen} onClose={() => setCheckoutOpen(false)} />
      <Concierge />
      <SocialProofToast />
      <ExitIntent onClaim={openCheckout} />
    </div>
  );
}
